<template>

    <div class="container-fluid">
        <div class="container-fluid">
                <div class="row d-flex justify-content-between">
                <div class="col-8">
                    <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                    <br>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
                </div>
                <div class="col-4">
                    <!-- <img class="img-rounded" src="@/assets/images/sick.png" height="40px" /><br> -->
                    <!-- <table v-for="item in patients" :key="item.id" class="table" density="compact" style="color:black">
                      
                   <tr><td>Full Name</td><td> {{ item.name }}</td></tr>
                    <tr><td>Gender</td><td> {{ item.gender }} </td></tr>
                    <tr><td> Telephone </td><td> {{ item.telephone }} </td></tr>
                    <tr><td> Date of Birth </td><td> {{ item.date_of_birth }} </td></tr>
                    <tr><td> Address </td><td> {{ item.address }} </td></tr>
                  
                    </table> -->

                    <table  class="table" density="compact" style="color:black" > 
                      <img class="img-rounded" :src="getPhotos(patient.photo)" height="40px" />
                      <tr><td>Full Name</td><td> {{ patient.name }}</td></tr>
                      <tr><td>Gender</td><td> {{ patient.gender }} </td></tr>
                      <tr><td> Telephone </td><td> {{ patient.telephone }} </td></tr>
                      <tr><td> Date of Birth </td><td> {{ patient.date_of_birth }} </td></tr>
                      <tr><td> Address </td><td> {{ patient.address }} </td></tr>

                    </table>
                 
                    <h5 class="my-3"><i class="mdi mdi-calendar"></i> &nbsp;&nbsp; {{ visit_date }}</h5>
                </div> 
          
            </div>
        </div>
        <div class="px-0 shadow">
              <div class="card-header ">
                <h4 class="mt-2 text-center text-decoration-underline">Referral Information</h4>
              </div>
              <div class="card-body ">
                <b class=" text-center">Investigations</b> <br><br>
                <span v-html="investigations" style="line-height: 10px;"></span><br><br>
                <b>Reason</b><br><br>
                <span v-html="reason" style="line-height: 10px;"></span><br><br>
                <b>Date</b> <br><br>
                <span v-html="referral_date" style="line-height: 10px;"></span><br><br>
                <b>Referred To</b><br><br>
                <span v-html="refer_to" style="line-height: 10px;"></span><br><br>

              </div>
              
                {{ date }}
              <div class="card-footer  ">
                <div class="mt-3 text-center">
                  <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                  <p style="color:black;font-size:13px">Printed by : {{ userData.username }} <br>  Via Afrimed Software | www.afrimed.com </p>
                </div>
              </div>
          </div>
        </div>
      </template>
      
      <script>
      import axios from "axios";
      export default {
        data() {
          return {
            patients:[],
            patientspinner:true,
            referralspinner:true,
            userData: JSON.parse(localStorage.getItem("user")),
            id:'',
            investigations:'',
            referral_date:new Date().toLocaleDateString('fr-CA'),
            refer_to:'',
            reason:'',
            visit_date:"",
            date:'',
            patientid:'',
            patient_id:'',
            referrals:[],
            patient:[],
                                 
          };
        },
        created() {
         this.fetchInfo();
         this.showreferral();
       
    
        },
        mounted() {
           
        setTimeout(() => {
            window.print();
            window.onafterprint=this.$router.go(-1);
        }, 5800);
        } ,
        methods: {
         getFiles(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"logos/"+name;
            return imagelink;
          },
          async fetchInfo(){
            this.id=this.$route.query.id;
            let url = `/visitinfo/${this.id}`;
            await axios.get(url).then((response) => {
              this.patient = response.data.visits[0].patient;
              
              // this.visitid = response.data.visits[0].visit_id;
              // this.service = response.data.visits[0].service_name.name;
              // this.service_id = response.data.visits[0].service_name.id;
              // this.visit_date = response.data.visits[0].addedon;
              this.showpatient();
              this.showreferral();
            });
          },
          async showpatient(){
            this.patientid=this.$route.query.patient_id;

            let url = `/patientprofile/${this.patientid}`;
            await axios.get(url).then((response) => {
             
              this.patients = response.data.patients;
              this.patientspinner=false;
             

            });
          },
          getPhotos(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"patients/"+name;
            return imagelink;
          },
    async showreferral(){
    
            this.id=this.$route.query.id;
            

            let url = `/printreferral/${this.id}`;
            await axios.get(url).then((response) => {
                       
           
            if (response.data.referrals.length===0) {
              this.patient = '';
              this.referral_date = '';
              this.investigations = '';
              this.reason = '';
              this.refer_to = '';
            }else{
              this.patient = response.data.referrals[0].patient;
              this.referral_date = response.data.referrals[0].referral_date;
              this.investigations = response.data.referrals[0].investigations;
              this.reason = response.data.referrals[0].reason;
              this.refer_to = response.data.referrals[0].refered_to;
              this.date = response.data.referrals[0].created_at;
            }
            });
          },
          
          
        },
      };
      </script>